import { Component, Input, OnInit} from '@angular/core';
import * as fileSaver from "file-saver";
import { SupplierTenderService } from '../../supplier/services/supplier-tender.service';
import { SupplierTenderModel } from '../../supplier/models/supplier-tender.model';
import { NzModalService } from 'ng-zorro-antd/modal';
import { TENDER_ERROR } from 'src/app/constants';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
  selector: 'app-attachment-modal',
  templateUrl: './attachment-modal.component.html',
  styleUrls: ['./attachment-modal.component.scss']
})
export class AttachmentModalComponent implements OnInit {

  @Input() selectedProductForShowAttachments;
  @Input() tenderId;

  listOfAttachmentColumn = [
		{
			title: "global.common.table_title.name",
			width: "80%",
		},
		{
			title: "global.common.table_title.size",
			width: "15%",
		},
		{
			title: "global.common.table_title.actions",
			width: "5%",
		},
	];

  constructor(
    private supplierTenderService: SupplierTenderService<SupplierTenderModel>,
    private modalService: NzModalService,
	private notificationService: NotificationService,
  ) { }

  ngOnInit(): void {
  }

  downloadAllProductAttachments(productId: string, productNumber: string) {
		this.supplierTenderService
			.downloadAllProductAttachments(this.tenderId, productId)
			.subscribe(
				(response) => {
					let blob: any = new Blob([response], { type: response.type });
					fileSaver.saveAs(
						blob,
						`${productNumber}.zip`
					);
				},
				async (err) => {
					console.error(err);
					const error = JSON.parse(await err.error.text());
					if (error.message === TENDER_ERROR.ATTACHMENT_NOT_FOUND || error.message === TENDER_ERROR.ATTACHMENT_DELETED) {
						this.notificationService.failureNotification('__attachment_not_found__');
					}
				}
			);
	}

  downloadProductAttachment(productId: string, data: { fileName: string; originalName: string; }) {
		this.supplierTenderService
			.downloadProductAttachments(this.tenderId, productId, data.fileName)
			.subscribe(
				(response) => {
					let blob: any = new Blob([response], { type: response.type });
					fileSaver.saveAs(
						blob,
						data.originalName
					);
				},
				async (err) => {
					console.error(err);
					const error = JSON.parse(await err.error.text());
					if (error.message === TENDER_ERROR.ATTACHMENT_NOT_FOUND || error.message === TENDER_ERROR.ATTACHMENT_DELETED) {
						this.notificationService.failureNotification('__attachment_not_found__');
					} else if (error.message === TENDER_ERROR.ATTACHMENT_IN_PROCESS) {
						this.notificationService.failureNotification('__attachment_in_process__');
					}
				}
			);
	}

     handleCancel(): void {
		this.modalService.closeAll();
	    }
}
